export function validateMobile(number) {
  const regex = /^\d{10}$/;
  return regex.test(number.trim());
}

export function validateEmail(email) {
  const regex = /^(([^<>#$()\[\]\\.$#,^'`~%*&=+{}|!;:\/\s@"]+(\.[^<>()\[\]\\.$#,^'`~%*&=+{}|!\/;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email).toLowerCase());
}

export function validatePincode(pincode) {
  const regex = /^\d{6}$/;
  return regex.test(pincode);
}

export function validateUsername(username) {
  const regex = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
  return regex.test(username);
}

export function validateFirstName(firstName) {
  const regex = /^[a-zA-Z,]+(\s{0,1}[a-zA-Z, ])*$/;
  return regex.test(firstName);
}

export function validatePassword(password) {
  const regex = /^((?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^*()_\-+]).{8,20})$/;
  // var regex = /^((?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^*()_\-+]).{8,20})$/;
  // var regex = /^.*(?=.{6,30})(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9!.,@#$%]+$/;
  // var regex = /^.*(?=.{6,30})(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9!@#$%]+$/;
  // var regex = /(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/
  // var regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/
  return regex.test(password);
}

export function validateASCIIChars(string) {
  if (!string) return ''; // handles undefined, null, ''
  const regex = /[^\x00-\x7F]/g;
  return string.replace(regex, '');
}

export function validateAlphaNumeric(number) {
  const regex = /^[a-zA-Z0-9]+$/;
  return regex.test(number.trim());
}

export function validateLandmark(string) {
  const regex = /^[a-z\d\-_\s]+$/i;
  return regex.test(string);
}

export function validateOthersAddressName(customAddressType) {
  const regex = /^[a-zA-Z-,.']+(\s{0,1}[a-zA-Z-,.' ])*$/;
  return regex.test(customAddressType);
}
export function validateGiftCardNumber(number) {
  const regex = /^[0-9]{16}/;
  return regex.test(number);
}
export function validateGiftCardPin(number) {
  const regex = /^[0-9]{6}/;
  return regex.test(number);
}
